import optionsApi from "./optionsApi";
import { ReportConfig } from "../pages/reports/customReportBuilder/types";

export async function saveCustomReport(config: ReportConfig) {
  return optionsApi
    .post("v1/customReport", config)
    .then((res) => res.data.data as { id: string });
}

export async function previewCustomReport(config: ReportConfig) {
  return optionsApi.post("v1/customReport/preview", config).then(
    (res) =>
      res.data.data as {
        sheets: {
          id: string;
          name: string;
          rows: Record<string, unknown>[];
          warnings: string[];
        }[];
      }
  );
}

export async function exportCustomReport(reportId: string) {
  return optionsApi.post(`v1/customReport/${reportId}/export`, {}).then(
    (res) =>
      res.data.data as {
        base64: string;
        contentType: string;
        fileName: string;
      }
  );
}

export interface CustomReportSummary {
  id: string;
  name: string;
  description: string | null;
  visibility: string;
  refreshSchedule: string;
  createdAt: string;
  updatedAt: string;
  canEdit: boolean;
  sheets: Array<{
    name: string;
    grain: string;
    columnCount: number;
    columns: string[];
  }>;
}

export async function listCustomReports(): Promise<CustomReportSummary[]> {
  return optionsApi.get("v1/customReport").then((res) => res.data.data ?? []);
}

export async function getCustomReport(id: string) {
  return optionsApi.get(`v1/customReport/${id}`).then(
    (res) =>
      res.data.data as {
        config: ReportConfig;
        canEdit: boolean;
      }
  );
}

export async function fetchReportSchema() {
  return optionsApi.get("v1/customReport/schema").then((res) => res.data.data);
}

export async function deleteCustomReport(reportId: string) {
  return optionsApi
    .delete(`v1/customReport/${reportId}`)
    .then((res) => res.data.data as { deleted: boolean });
}

export async function generateCustomReport(
  reportId: string,
  opts?: { maskPii?: boolean; scheduleParams?: unknown }
) {
  return optionsApi
    .post(`v1/customReport/${reportId}/generate`, opts ?? {})
    .then(
      (res) =>
        res.data.data as {
          queued: boolean;
          scheduled: boolean;
          message: string;
        }
    );
}
